import { IconProps } from "./icon.type";

export function IcGlobeShield({ ...props }: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0002 28.8004C19.395 28.8004 22.6507 27.4519 25.0512 25.0514C27.4516 22.6509 28.8002 19.3952 28.8002 16.0004C28.8002 12.6057 27.4516 9.34994 25.0512 6.94947C22.6507 4.54901 19.395 3.20044 16.0002 3.20044C12.6054 3.20044 9.34969 4.54901 6.94923 6.94947C4.54876 9.34994 3.2002 12.6057 3.2002 16.0004C3.2002 19.3952 4.54876 22.6509 6.94923 25.0514C9.34969 27.4519 12.6054 28.8004 16.0002 28.8004Z"
        fill="url(#paint0_linear_2360_916)"
      />
      <path
        d="M16.0002 28.8004C19.395 28.8004 22.6507 27.4519 25.0512 25.0514C27.4516 22.6509 28.8002 19.3952 28.8002 16.0004C28.8002 12.6057 27.4516 9.34994 25.0512 6.94947C22.6507 4.54901 19.395 3.20044 16.0002 3.20044C12.6054 3.20044 9.34969 4.54901 6.94923 6.94947C4.54876 9.34994 3.2002 12.6057 3.2002 16.0004C3.2002 19.3952 4.54876 22.6509 6.94923 25.0514C9.34969 27.4519 12.6054 28.8004 16.0002 28.8004Z"
        fill="url(#paint1_radial_2360_916)"
        fillOpacity="0.7"
      />
      <path
        d="M16.0002 28.8004C19.395 28.8004 22.6507 27.4519 25.0512 25.0514C27.4516 22.6509 28.8002 19.3952 28.8002 16.0004C28.8002 12.6057 27.4516 9.34994 25.0512 6.94947C22.6507 4.54901 19.395 3.20044 16.0002 3.20044C12.6054 3.20044 9.34969 4.54901 6.94923 6.94947C4.54876 9.34994 3.2002 12.6057 3.2002 16.0004C3.2002 19.3952 4.54876 22.6509 6.94923 25.0514C9.34969 27.4519 12.6054 28.8004 16.0002 28.8004Z"
        fill="url(#paint2_radial_2360_916)"
        fillOpacity="0.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5654 3.66605C12.0327 4.41478 11.5942 5.22621 11.2598 6.08205C10.671 7.53165 10.2198 9.27405 9.93819 11.2004H4.12859C3.92059 11.7178 3.74459 12.2511 3.60059 12.8004H9.74459C9.55078 14.9294 9.55131 17.0716 9.74619 19.2004H3.60219C3.74619 19.7498 3.92219 20.2831 4.13019 20.8004H9.93819C10.2198 22.7268 10.671 24.4692 11.2598 25.9188C11.5942 26.7747 12.0327 27.5861 12.5654 28.3348C13.684 28.6451 14.8397 28.8017 16.0006 28.8004C17.1615 28.8017 18.3171 28.6451 19.4358 28.3348C19.9684 27.5861 20.4069 26.7747 20.7414 25.9188C21.3302 24.4692 21.7814 22.7268 22.063 20.8004H27.871C28.079 20.2831 28.2545 19.7498 28.3974 19.2004H22.2534C22.4513 17.0717 22.4513 14.9292 22.2534 12.8004H28.3974C28.2567 12.2561 28.0803 11.7216 27.8694 11.2004H22.0646C21.783 9.27405 21.3318 7.53165 20.743 6.08205C20.4085 5.22621 19.97 4.41478 19.4374 3.66605C18.3182 3.35565 17.162 3.19901 16.0006 3.20045C14.8397 3.19916 13.684 3.35579 12.5654 3.66605ZM11.5574 11.2004C11.823 9.47885 12.2294 7.94445 12.7414 6.68525C13.2182 5.51245 13.7686 4.61805 14.3462 4.02925C14.919 3.44525 15.4758 3.20045 16.0006 3.20045C16.5254 3.20045 17.0822 3.44525 17.655 4.02925C18.231 4.61805 18.783 5.51245 19.2598 6.68525C19.7718 7.94445 20.1782 9.47885 20.4438 11.2004H11.5574ZM16.0006 28.8004C16.5254 28.8004 17.0822 28.5556 17.655 27.9716C18.231 27.3828 18.783 26.4884 19.2598 25.3156C19.7718 24.0564 20.1782 22.522 20.4438 20.8004H11.5574C11.8246 22.522 12.231 24.0564 12.743 25.3156C13.2198 26.4884 13.7702 27.3828 14.3478 27.9716C14.9206 28.5556 15.4774 28.8004 16.0022 28.8004M11.2022 16.0004C11.2022 17.1076 11.255 18.1796 11.3558 19.2004H20.6486C20.7501 18.1368 20.8008 17.0689 20.8006 16.0004C20.8006 14.8932 20.7478 13.8212 20.647 12.8004H11.3542C11.2521 13.8641 11.2025 14.9319 11.2022 16.0004Z"
        fill="url(#paint3_radial_2360_916)"
      />
      <path
        d="M22.3996 29.6394C20.5196 28.6746 17.6476 26.5274 17.5996 22.401V18.3018C17.5996 17.8586 17.9596 17.5066 18.398 17.4442C20.59 17.1354 22.374 15.6298 23.3036 14.6842C23.3946 14.5926 23.5032 14.5203 23.6228 14.4717C23.7423 14.423 23.8705 14.399 23.9996 14.401C24.2556 14.401 24.5116 14.4954 24.6956 14.6842C25.6236 15.6298 27.4092 17.1354 29.6012 17.4442C30.0396 17.5066 30.3996 17.8602 30.3996 18.3018V22.401C30.3516 26.5274 27.4796 28.6746 25.5996 29.6394C25.1507 29.8714 24.6855 30.0703 24.2076 30.2346C24.0728 30.2809 23.9264 30.2809 23.7916 30.2346C23.3138 30.0703 22.8485 29.8714 22.3996 29.6394Z"
        fill="#A0D911"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2360_916"
          x1="8.8898"
          y1="7.46764"
          x2="27.3778"
          y2="24.5332"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#29C3FF" />
          <stop offset="1" stopColor="#2052CB" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_2360_916"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.901 22.602) rotate(180) scale(10.7539)"
        >
          <stop stopColor="#003580" />
          <stop offset="1" stopColor="#003580" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_2360_916"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24.4002 22.4004) rotate(37.2782) scale(16.8405 18.2682)"
        >
          <stop offset="0.412" stopColor="#1B44B1" />
          <stop offset="1" stopColor="#1B44B1" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_2360_916"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24.0006 22.4036) rotate(45.0162) scale(19.2387 20.5507)"
        >
          <stop offset="0.445" stopColor="#3BD5FF" stopOpacity="0" />
          <stop offset="0.815" stopColor="#3BD5FF" />
        </radialGradient>
      </defs>
    </svg>
  );
}
